import {
    Component,
    ViewChild,
    TemplateRef,
    AfterViewInit,
    ChangeDetectorRef,
    ElementRef,
    OnDestroy,
  } from "@angular/core";
  import {
    MatRowDef,
    MatTableModule,
  } from "@angular/material/table";
  import { MatDialogModule, MatDialog, MatDialogRef } from "@angular/material/dialog";
  import { CommonModule, NgIf } from "@angular/common";
  import { MatButtonModule } from "@angular/material/button";
  import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
  import { MatFormFieldModule } from "@angular/material/form-field";
  import { MatInputModule } from "@angular/material/input";
  import {
    MatPaginator,
    MatPaginatorIntl,
    MatPaginatorModule,
    PageEvent,
  } from "@angular/material/paginator";
  import { MatSort, MatSortModule } from "@angular/material/sort";
  import { MatSelectModule } from "@angular/material/select";
  import { MatIcon, MatIconModule } from "@angular/material/icon";
  import { MatSlideToggle } from "@angular/material/slide-toggle";
  import { MatOptionModule } from "@angular/material/core";
  import { MatTooltipModule } from "@angular/material/tooltip";
  import { MatExpansionModule } from "@angular/material/expansion";
  import { CompanyAttributes } from "@albatrosdeveloper/ave-models-package";
  import { MatSnackBar } from "@angular/material/snack-bar";
  import { CompanyService } from "../../configuration/company/company.service.service";
  import MotiveBlockAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/motive-block-business-partner/motive-block-business-partner.entity";
  import { MatSidenavContainer } from "@angular/material/sidenav";
  import { MatMenuModule } from "@angular/material/menu";
  import { MatTabsModule } from "@angular/material/tabs";
  import {
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    NgSelectModule,
  } from "@ng-select/ng-select";
  import { ICreateReasonBlock } from "./interfaces/create-reason-for-block.interface";
  import { ReasonBlockService } from "./reasons-for-block.service";
  import { IUpdateReasonBlock } from "./interfaces/update-reason-for-block.interface";
  import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
  import { getCode } from 'app/utils/method';
import { FilterComponent } from "app/common/components/filter/filter.component";
import { Subscription } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";


  @Component({
    selector: "app-reason-for-block",
    templateUrl: "./reasons-for-block.component.html",
    styleUrls: ["./reasons-for-block.component.scss"],
    standalone: true,
    imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    FilterComponent,
    StatusFiltersComponent,
    FilterSectionComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
],
    providers: [
      { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    ],
  })
  export class ReasonForBlockComponent implements AfterViewInit, OnDestroy{
    getCode = getCode;
    displayedColumns: string[] = ["name", "status", "actions"];
    currentCreateReasonBlock: ICreateReasonBlock =
      this.initializeCreateReasonBlock();
    currentUpdateReasonBlock: MotiveBlockAttributes | undefined;
  
    dataSource: MotiveBlockAttributes[] = [];
    companyList: CompanyAttributes[] = [];
  
    searchQuery: string = "";
    totalItems: number = 0;
    pageSize: number = 50;
    pageIndex: number = 0;

    dialogRefAdd: MatDialogRef<any>;
    dialogRefEdit:MatDialogRef<any>;

    selectedStatuses: number[] = [];
  
    @ViewChild("editModal") editModal!: TemplateRef<any>;
    @ViewChild("addModal") addModal!: TemplateRef<any>;
    @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    @ViewChild("searchInput") searchInput!: ElementRef;
  
    //BUSCADOR
    searchSubscription: Subscription;

    companyFormGroup = new FormGroup({
      companyId: new FormControl<number | null>(null),
    })
    
    constructor(
      private readonly reasonBlockService: ReasonBlockService,
      private companyService: CompanyService,
      private readonly searchService: SearchService,
      private dialog: MatDialog,
      private snackBar: MatSnackBar,
      private cdr: ChangeDetectorRef
    ) {}
  
    ngAfterViewInit(): void {
      this.onHandleSearch();
      this.setupPaginationAndSorting();
      this.fetchAllCompanies();
    }
  
    private fetchAllCompanies(): void {
      this.companyService.findToComboBox().subscribe({
        next: (res) => {
          this.companyList = res.data;
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al obtener compañias.","Cerrar",{ duration: 5000});
        },
      });
    }  
    private initializeCreateReasonBlock(): ICreateReasonBlock {
      return { name: "", companyId: "", useGps: false };
    }
  
    private setupPaginationAndSorting(): void {
      this.paginator.page.subscribe(() => this.findAllWithCount());
      this.sort.sortChange.subscribe(() => {
        this.paginator.pageIndex = 0;
        this.findAllWithCount();
      });
    }
  
    findAllWithCount(): void {
      const pageIndex = this.paginator.pageIndex + 1;
      const sortField = this.getSortField();
      const sortDirection: "ASC" | "DESC" =
        this.sort.direction === "asc" ? "ASC" : "DESC";
  
      this.reasonBlockService
        .findAllWithCount({
          currentPage: pageIndex,
          limitPerPage: this.pageSize,
          search: this.searchQuery,
          sort: sortField,
          sortDirection: sortDirection,
        },
      [this.companyFormGroup.value.companyId], this.selectedStatuses)
        .subscribe((data) => {
          this.dataSource = data?.data?.[0]?.data ?? [];
          this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
          this.paginator.length = this.totalItems;
        });
    }
  
    private getSortField(): keyof MotiveBlockAttributes {
      const validSortFields: (keyof MotiveBlockAttributes)[] = [
        "name",
        "statusId",
      ];
      return validSortFields.includes(
        this.sort.active as keyof MotiveBlockAttributes
      )
        ? (this.sort.active as keyof MotiveBlockAttributes)
        : "name";
    }
  
    onPageChange(event: PageEvent): void {
      this.pageSize = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.findAllWithCount();
    }
  
    onSearchChange(event: Event): void {
      const input = event.target as HTMLInputElement;
      this.searchQuery = input.value.trim();
      if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
        this.paginator.pageIndex = 0;
        this.findAllWithCount();
      }
    }

    public onHandleSearch(){
      this.searchSubscription = this.searchService.searchTerm$
        .subscribe(term => {
          this.searchQuery = term;
          if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
            this.paginator.pageIndex = 0;
            this.findAllWithCount();
          }
        });
    }
  
    trackByFn(index: number, item: MotiveBlockAttributes): string {
      return item._id.toString();
    }
  
    openCreateModal(): void {
      this.currentCreateReasonBlock = this.initializeCreateReasonBlock();
      this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose:true })
      // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createReasonVisit());
      this.dialogRefAdd.afterClosed().subscribe((result) => { result });
    }
  
    openEditModal(condition: MotiveBlockAttributes): void {
      this.currentUpdateReasonBlock = { ...condition };
      this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose:true })
      // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateReasonBlock(condition._id.toString()));
      this.dialogRefEdit.afterClosed().subscribe((result) => { result });
    }
  
    createReasonVisit(): void {
      this.reasonBlockService.create(this.currentCreateReasonBlock).subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRefAdd.close();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  
    updateReasonBlock(id: string): void {
      if (this.currentUpdateReasonBlock) {
        const updatedReasonBlock: IUpdateReasonBlock = {
          ...this.currentUpdateReasonBlock,
          companyId: this.currentUpdateReasonBlock.company._id.toString(),
        };
  
        this.reasonBlockService.update(id, updatedReasonBlock).subscribe({
          next: () => {
            this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
              duration: 3000,
            });
            this.findAllWithCount();
            this.dialogRefEdit.close();
          },
          error: (err) => {
            this.snackBar.open(
              err.error.message || "Error al actualizar el registro",
              "Cerrar",
              { duration: 3000 }
            );
          },
        });
      }
    }
  
    onStatusChange(event: boolean, condition: MotiveBlockAttributes): void {
      const originalStatusId = condition.statusId;
      const updatedStatusId = event ? 1 : 0;
      const updatedReasonBlock = { ...condition, statusId: updatedStatusId };
  
      this.reasonBlockService
        .update(condition._id.toString(), updatedReasonBlock)
        .subscribe({
          next: () => {
            this.findAllWithCount();
          },
          error: () => {
            condition.statusId = originalStatusId; // Volver al estado original si falla
            this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
              duration: 3000,
            });
            this.findAllWithCount();
          },
        });
    }
  
    openDeleteDialog(condition: MotiveBlockAttributes): void {
      this.dialog
        .open(this.deleteDialog, { data: condition, panelClass: "delete-modal", disableClose:true })
        .afterClosed()
        .subscribe((result) => result && this.delete(condition._id.toString()));
    }
  
    delete(id: string): void {
      this.reasonBlockService.remove(id).subscribe(() => {
        this.findAllWithCount();
        this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
          duration: 3000,
        });
      });
    }
  
    compareById(item1: any, item2: any): boolean {
      return item1 && item2 ? item1._id === item2._id : item1 === item2;
    }
  
   
    clearFilters(): void {
      this.selectedStatuses = [];
      this.searchQuery = "";
      this.companyFormGroup.reset();
      this.findAllWithCount();
    }
  
    ngOnDestroy(): void {
      this.searchSubscription.unsubscribe();
    }

    applyStatusFilter(): void {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }
  